import { render, staticRenderFns } from "./Importacao.vue?vue&type=template&id=0b1e3746&lang=html"
import script from "./Importacao.vue?vue&type=script&lang=js"
export * from "./Importacao.vue?vue&type=script&lang=js"
import style0 from "./Importacao.vue?vue&type=style&index=0&id=0b1e3746&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports